import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router'
import { cn } from '@/lib/utils'

/**
 * The actions feed, from the deployment's side.
 *
 * Three questions rather than three readings of one: what the checks are
 * currently saying, whether each check is still running everywhere it should
 * be, and whether the kinds of change they ask for move anything. The last two
 * are invisible from the list — a detector that has been failing for a week
 * produces the same empty list as a site with nothing wrong.
 *
 * Pathless, so a single action stays out of it: a row's own page is one click
 * deep and has no use for a nav across the section.
 */
export const Route = createFileRoute('/_app/admin/actions/_list')({
  component: ActionsLayout,
})

const SECTIONS = [
  { to: '/admin/actions', leaf: 'actions', label: 'List' },
  { to: '/admin/actions/detectors', leaf: 'detectors', label: 'Detectors' },
  { to: '/admin/actions/efficacy', leaf: 'efficacy', label: 'Efficacy' },
] as const

function ActionsLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const leaf = pathname.replace(/\/$/, '').split('/').filter(Boolean).at(-1) ?? 'actions'

  return (
    <>
      <nav className="mb-4 flex flex-wrap gap-1">
        {SECTIONS.map((section) => (
          <Link
            key={section.leaf}
            to={section.to}
            className={cn(
              'rounded-md px-2.5 py-1.5 text-[13px] transition-colors',
              leaf === section.leaf
                ? 'bg-plum-selected text-foreground'
                : 'text-muted-foreground hover:bg-accent hover:text-foreground',
            )}
          >
            {section.label}
          </Link>
        ))}
      </nav>

      <Outlet />
    </>
  )
}
